module.exports = __webpack_public_path__ + "img/search.cc0f33b0.svg";